/**
 * 產品相關enum
 */
export namespace PRODUCT_ENUM {
    

    /**
     * 導熱係數選項List
     * 
     * 依照現有產品設置選項PI_TIM, SILICON_TIM, GLASS_TIM
     * 無產品暫時先與TIM相同
     */
    export const THERMAL_COEFFICIENT: {
        [key: string]: number[]
    } = {
        TIM: [1.0, 2.0, 3.0, 4.0, 5.0, 6.0, 8.0, 10.0],
        TMP: [1.0, 1.5, 2.0, 3.0, 4.0, 5.0],
    }

    /**
     * 主要聯絡人
     */
    export const CONACT_PERSON = 'marina@a-sink.com';
}